import api from "../config/api";
import { Module } from "../types/Module";

const API_URL = "/module";

export const getModules = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

export const getModuleById = (id: number) => api.get(`${API_URL}/?id=${id}`);

export const getModuleByPojectId = (projectId: number) =>
  api.get(`${API_URL}/?projectId=${projectId}`);

export const createModule = (data: Module) => api.post(`${API_URL}/`, data);

export const updateModule = (id: number, data: Module) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteModule = (id: number) => api.delete(`${API_URL}/?id=${id}`);
